import { useParams } from 'react-router-dom';
import { useProject } from './useProjects';

export const useCurrentProject = () => {
  const { pid } = useParams<{ pid: string }>();
  return useProject(pid!);
};
